import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalProps } from 'dig-components/modal';
import { Text } from 'dig-components/typography';
import AdvancedSearchForm from 'ui/advanced-search/advanced-form';
import { trackHeapCustomEvent } from 'common/utils/heap';

import styles from './search.scss';

const AdvancedSearchModal = ({
  defaultQuery,
  hasTeamRequestTab,
  onSearch,
  ...props
}: ModalProps & {
  defaultQuery: string,
  hasTeamRequestTab: boolean,
  onSearch: (q: string) => void,
}) => {
  const [defaultFilter] = React.useState(() => {
    const matches = defaultQuery.match(/filter:(\w+)/);

    return matches ? matches[1] : '';
  });

  const [defaultSigner] = React.useState(() => {
    const matches = defaultQuery.match(/to:"(\w+)"/);

    return matches ? matches[1] : '';
  });

  const [defaultSender] = React.useState(() => {
    const matches = defaultQuery.match(/from:"(\w+)"/);

    return matches ? matches[1] : '';
  });

  const [defaultCreatedFrom] = React.useState(() => {
    const matches = defaultQuery.match(/created:\[(.+)\]/);

    return matches ? matches[1].split(' TO ')[1] : '';
  });

  const [defaultCreatedTo] = React.useState(() => {
    const matches = defaultQuery.match(/created:\[(.+)\]/);

    return matches ? matches[1].split(' TO ')[0] : '';
  });

  const [defaultContains] = React.useState(() => {
    return defaultQuery.replace(/\s?\w+:.*/, '');
  });

  const [defaultOwner] = React.useState(() => {
    const matches = defaultQuery.match(/owner:"(\w+)"/);

    return matches ? matches[1] : '';
  });

  const [defaultTestMode] = React.useState(() => {
    const matches = defaultQuery.match(/test_mode:(\w+)/);

    return matches ? matches[1] === 'true' : false;
  });

  const onSearchProxy = React.useCallback((data) => {
    const queryParts = [data.contains];

    if (data.filter) {
      queryParts.push(`filter:${data.filter}`);
    }

    if (data.signer) {
      queryParts.push(`to:"${data.signer}"`);
    }

    if (data.sender) {
      queryParts.push(`from:"${data.sender}"`);
    }

    if (data.created) {
      queryParts.push(`created:${data.created}`);
    }

    if (data.owner) {
      queryParts.push(`owner:"${data.owner}"`);
    }

    if (data.testMode) {
      queryParts.push('test_mode:true');
    }

    const q = queryParts.join(' ').trim();

    trackHeapCustomEvent('docs_redesign_perform_advanced_search');
    onSearch(q);
  }, [onSearch]);

  return (
    <Modal
      withCloseButton="Close"
      isCentered
      {...props}
    >
      <>
        <Modal.Header hasBottomSpacing="title-standard">
          <Text
            size="large"
            variant="label"
            isBold
          >
            <FormattedMessage
              id=""
              description="Title for a modal with advanced search tools."
              defaultMessage="Advanced search" />
          </Text>
        </Modal.Header>
        <Modal.Body>
          <AdvancedSearchForm
            defaultFilter={defaultFilter}
            defaultSigner={defaultSigner}
            defaultSender={defaultSender}
            defaultCreatedFrom={defaultCreatedFrom}
            defaultCreatedTo={defaultCreatedTo}
            defaultContains={defaultContains}
            defaultOwner={defaultOwner}
            defaultTestMode={defaultTestMode}
            className={styles.advancedSearchForm}
            siteCode="s"
            includeAllTeam={hasTeamRequestTab}
            onSearch={onSearchProxy} />
        </Modal.Body>
      </>
    </Modal>
  );
};

export default AdvancedSearchModal;
